import { useState } from "react";

type Props = { address: string };
type CopyState = "idle" | "copied" | "failed";

/** The address in full, selectable, with a copy button that reports what actually happened. */
export function AddressField({ address }: Props) {
  const [copy, setCopy] = useState<CopyState>("idle");

  function copyAddress() {
    navigator.clipboard.writeText(address).then(
      () => {
        setCopy("copied");
      },
      () => {
        setCopy("failed");
      },
    );
  }

  return (
    <div className="address-field">
      <code className="address-field__value" data-testid="solana-address">
        {address}
      </code>
      <button type="button" className="address-field__copy" onClick={copyAddress}>
        Copy address
      </button>
      <p className="address-field__status" role="status" aria-live="polite">
        {copy === "copied" ? "Address copied." : null}
        {copy === "failed" ? "Copying was blocked. Select the address and copy it by hand." : null}
      </p>
    </div>
  );
}
